export default __webpack_public_path__ + "static/media/Rastech-update-go.16ddcd3d.png";